import { Text } from "~/components/Text"
import { useState } from "react"
import { CloseOutlined } from "@ant-design/icons"
import { Button, Flex } from "antd"
import { useLocation } from "react-router"
import { ROUTER } from "~/common/router"
import styles from "./index.css"

export const ModelLaunchNotice = () => {
  const { pathname } = useLocation()
  const [closed, setClosed] = useState(false)

  if (closed || pathname !== ROUTER.HOME) return null

  return (
    <Flex
      align="center"
      className={styles.banner}
      gap={12}
      justify="center"
      role="status"
      wrap
    >
      <Text
        size="s"
        color="inherit"
        className={styles.badge}
      >
        🚀 NEW
      </Text>
      <Text
        size={13}
        color="inherit"
        className={styles.message}
      >
        <strong>Wan 3.0 官方大模型正式接入！</strong>
        <span className={styles.separator}>｜</span>
        支持真人图片参考 · 单次最长生成 30 秒视频 · 计费性价比更高！
      </Text>
      <Button
        aria-label="关闭模型上线公告"
        className={styles.closeButton}
        icon={<CloseOutlined />}
        onClick={() => setClosed(true)}
        size="small"
        type="text"
      />
    </Flex>
  )
}
